const initialState = {
  patient: {
    constrain: [],
    display_contam: false,
    overlap_level: "ward",
    contam_period: 28, // 4 weeks
    inf_period_prior: 0, // 0 days
    inf_period_after: 56, // 8 weeks
    incubation: 84, // 12 weeks
    test_time_buffer: 1, // 1 day
  },
  contact_list: {},
  tree: {
    name_map: {},
    name_map_snp2: null,
    constrain: [],
    overlap_constraint: false,
    constraint_loading: false,
    constraint_loading_count: 0,
    heatmap_selected: false,
    show_future_sequences: false,
  },

  snp_distance: "5",
  overlapView: "overlaps",
  graph: {
    info: true,
    edge_width_param: "duration",
    edge_colour_param: "None",
    constrain: [],
    highlightPhylos: false,
    pruneForPhylos: false,
    key: null,
    loading: false,
    progress: 0,
  },
  layers: 3,
  viewHistory: [],
};

export function patientReducer(state = initialState, action) {
  switch (action.type) {
    case "STORE_PT_OBJ_SUCCEEDED": {
      return {
        ...state,
        micro_id: action.payload.micro_id,
        patient: {
          ...state.patient,
          ...action.payload.pt_object,
        },
      };
    }
    case "SELECT_LEVEL_SUCCEEDED": {
      return {
        ...state,
        patient: {
          ...state.patient,
          overlap_level: action.payload.level,
        },
      };
    }
    case "SELECT_CONTAM_PERIOD_SUCCEEDED": {
      return {
        ...state,
        patient: {
          ...state.patient,
          contam_period: action.payload.contam_period,
        },
      };
    }
    case "CONSTRAIN_OVERLAP_SUCCEEDED": {
      return {
        ...state,
        patient: {
          ...state.patient,
          constrain: action.payload.leaves,
        },
      };
    }
    case "SELECT_INF_PRIOR_SUCCEEDED": {
      return {
        ...state,
        patient: {
          ...state.patient,
          inf_period_prior: action.payload.inf_period_prior,
        },
      };
    }
    case "SELECT_INF_AFTER_SUCCEEDED": {
      return {
        ...state,
        patient: {
          ...state.patient,
          inf_period_after: action.payload.inf_period_after,
        },
      };
    }
    case "SELECT_TTB_SUCCEEDED": {
      return {
        ...state,
        patient: {
          ...state.patient,
          test_time_buffer: action.payload.test_time_buffer,
        },
      };
    }
    case "SELECT_INCUBATION_PERIOD_SUCCEEDED": {
      return {
        ...state,
        patient: {
          ...state.patient,
          incubation: action.payload.incubation,
        },
      };
    }

    case "STORE_VIEWED_OBJ_SUCCEEDED": {
      return state.viewHistory.some(
        (e) => e.micro_id === action.payload.micro_id
      )
        ? state
        : {
            ...state,
            viewHistory: [
              ...state.viewHistory,
              { micro_id: action.payload.micro_id, name: action.payload.name },
            ],
          };
    }
    case "STORE_CONTACT_LIST_SUCCEEDED": {
      return {
        ...state,
        contact_list: action.payload.contact_list,
      };
    }
    case "STORE_TREE_SUCCEEDED": {
      return {
        ...state,
        tree: {
          ...state.tree,
          tree: action.payload.tree,
          distance_matrix: action.payload.matrix,
          name_map: action.payload.name_map,
        },
      };
    }
    case "CONSTRAIN_TREE_SUCCEEDED": {
      return {
        ...state,
        tree: {
          ...state.tree,
          constrain: action.payload.srces,
        },
      };
    }
    case "STORE_TREE_SNP2_NAMEMAP_SUCCEEDED": {
      return {
        ...state,
        tree: {
          ...state.tree,
          name_map_snp2: action.payload.name_map_snp2,
        },
      };
    }
    case "STORE_SNP_DIST_SUCCEEDED": {
      return {
        ...state,
        snp_distance: action.payload.snp_dist,
        tree: {
          ...state.tree,
          tree: undefined, // force reload so treechart waits for new data
          distance_matrix: undefined,
          name_map: {},
        },
      };
    }
    case "STORE_GRAPH_SUCCEEDED": {
      return {
        ...state,
        graph: {
          ...state.graph,
          nodes: action.payload.nodes,
          edges: action.payload.edges,
          key: action.payload.key ?? state.graph.key,
          loading: false,
          progress: 100,
        },
      };
    }
    case "STORE_LAYERS_SUCCEEDED": {
      return {
        ...state,
        layers: action.payload.layers,
      };
    }
    case "TOGGLE_GRAPH_INFO": {
      return {
        ...state,
        graph: {
          ...state.graph,
          info: action.payload.toggled,
        },
      };
    }
    case "EDGE_WIDTH_PARAM": {
      return {
        ...state,
        graph: {
          ...state.graph,
          edge_width_param: action.payload.param,
        },
      };
    }
    case "EDGE_COLOUR_PARAM": {
      return {
        ...state,
        graph: {
          ...state.graph,
          edge_colour_param: action.payload.param,
        },
      };
    }
    case "GRAPH_LOADING_START": {
      return {
        ...state,
        graph: {
          ...state.graph,
          loading: true,
        },
      };
    }
    case "GRAPH_LOADING_END": {
      return {
        ...state,
        graph: {
          ...state.graph,
          loading: false,
        },
      };
    }
    case "GRAPH_PROGRESS_SET": {
      return {
        ...state,
        graph: {
          ...state.graph,
          progress: action.payload,
        },
      };
    }
    case "CONSTRAIN_GRAPH_SUCCEEDED": {
      return {
        ...state,
        graph: {
          ...state.graph,
          constrain: action.payload.leaves,
          pruneForPhylos: action.payload.pruneForPhylos,
        },
      };
    }
    case "HIGHLIGHT_PHYLOS_SUCCEEDED": {
      return {
        ...state,
        graph: {
          ...state.graph,
          constrain: action.payload.leaves,
          highlightPhylos: action.payload.highlightPhylos,
        },
      };
    }
    case "HEATMAP_SELECT_SUCCEEDED": {
      return {
        ...state,
        tree: {
          ...state.tree,
          heatmap_selected: action.payload,
        },
      };
    }
    case "SET_OVERLAP_VIEW": {
      return {
        ...state,
        overlapView: action.payload.view,
      };
    }
    case "CONSTRAIN_BY_OVERLAP": {
      return {
        ...state,
        tree: {
          ...state.tree,
          overlap_constraint: action.payload,
        },
      };
    }
    case "CONSTRAINT_LOADING_START": {
      const count = (state.tree.constraint_loading_count || 0) + 1;
      return {
        ...state,
        tree: {
          ...state.tree,
          constraint_loading_count: count,
          constraint_loading: true,
        },
      };
    }
    case "CONSTRAINT_LOADING_END": {
      const count = Math.max((state.tree.constraint_loading_count || 1) - 1, 0);
      return {
        ...state,
        tree: {
          ...state.tree,
          constraint_loading_count: count,
          constraint_loading: count > 0,
        },
      };
    }
    case "CONSTRAINT_LOADING_RESET": {
      return {
        ...state,
        tree: {
          ...state.tree,
          constraint_loading_count: 0,
          constraint_loading: false,
        },
      };
    }
    case "SHOW_FUTURE_SEQUENCES_SUCEEDED": {
      return {
        ...state,
        tree: {
          ...state.tree,
          show_future_sequences: action.payload,
        },
      };
    }
    case "RESET": {
      return {
        ...initialState,
      };
    }
    case "LOGOUT": {
      return {
        ...initialState,
      };
    }

    default: {
      return state;
    }
  }
}
